import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';
import { PwaInstallBannerComponent } from '../pwa-install-banner/pwa-install-banner.component';
import { PushNotificationDialogComponent } from '../push-notification-dialog/push-notification-dialog.component';

@Component({
  selector: 'app-page-wrapper',
  imports: [HeaderComponent, FooterComponent, PwaInstallBannerComponent, RouterOutlet, PushNotificationDialogComponent],
  templateUrl: './page-wrapper.component.html',
  styleUrl: './page-wrapper.component.scss',
})
export class PageWrapperComponent {}
